import React,{useEffect, useRef} from 'react';
import NavElementStyles from './NavElement.module.css';
import HamburgerStyles from '../HamburgerButton/HamburgerButton.module.css';


function closeMobileNavModal({mobileNavModalDOM,hamburgerButtonDOM}){
    mobileNavModalDOM.classList.remove(HamburgerStyles['Open']);
    hamburgerButtonDOM.classList.remove(HamburgerStyles['isActive']);
}
export default function NavElement({link,name,disabled,mobileNavModalRef,hamburgerButtonRef}){
    const navElementListItemRef=useRef(null);
    useEffect(()=>{
        if (!mobileNavModalRef || !hamburgerButtonRef)
            return;
        const {current:navElementListItemDOM}=navElementListItemRef;
        const {current:hamburgerButtonDOM}=hamburgerButtonRef;
        const {current:mobileNavModalDOM}=mobileNavModalRef;
        navElementListItemDOM.addEventListener('click',closeMobileNavModal.bind(null,{mobileNavModalDOM,hamburgerButtonDOM}));
        return navElementListItemDOM.removeEventListener('click',closeMobileNavModal.bind(null,{mobileNavModalDOM,hamburgerButtonDOM}));
    },[hamburgerButtonRef, mobileNavModalRef])
    return <li ref={navElementListItemRef} className="nav-item">
                <a 
                    className={`nav-link ${disabled && `disabled ${NavElementStyles.Disabled}`} 
                        ${NavElementStyles.NavElement}`} 
                    aria-current="page" 
                    href={link?link:''}>{name}
                </a>
            </li>
}